import api from './api';

// import {RegisterInterface} from "../auth/auth_request";

export interface TermsBody{
    terms_id: number
}

export interface TermsCheckRequest {
    current_terms: {
        id: number
        version: string
        title: string
        data_create: string
    },
    has_accepted: boolean
    acceptance_required: boolean
}

export interface TermsCurrentRequest {
    id: number
    version: string
    title: string
    text: string
    date_created: string
}

// const getCsrfToken = (): string | null => {
//     try {
//         const cookies = document.cookie.split(';');
//         for (const cookie of cookies) {
//             const [name, value] = cookie.trim().split('=');
//             if (name === 'csrftoken') {
//                 return value;
//             }
//         }
//         return null;
//     } catch (error) {
//         console.error('Error al obtener CSRF token:', error);
//         return null;
//     }
// };

export const termsAccepted = async (termsId: number) => {
  try {
    // const csrfToken = getCsrfToken();
    // if (!csrfToken) {
    //   throw new Error('CSRF token no encontrado');
    // }

    const response = await api.post('/api/terms/accept/', 
      { terms_id: termsId },
      {
        headers: {
          // 'X-CSRFToken': csrfToken,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error al aceptar los términos:', error);
    throw error;
  }
};

export const getCurrentTerms = async () => {
  try {
    const response = await api.get('/api/terms/current/');
    return response.data;
  } catch (error) {
    console.error('Error al obtener los términos actuales:', error);
    throw error;
  }
};

export const checkTermsAcceptance = async () => {
  try {
    const response = await api.get('/api/terms/check/');
    return response.data;
  } catch (error) {
    console.error('Error al verificar la aceptación de términos:', error);
    throw error;
  }
};